// test932
(932 && 0);
